import React, {Component} from 'react';
import { withStyles } from '@material-ui/core/styles';
import I18n from 'lib/i18n/i18n';
import TextField from '@material-ui/core/TextField'
import WorthyApi from "lib/api/worthyApi";

const styles = theme => ({
    label: {
        '&$cssFocused': {
          color: '#F5A723'
        },
    },
    outlined: {
        '&$cssFocused $notchedOutline': {
          borderColor: '#F5A723'
        },
    },
    errorLabel: {
        '&$cssFocused': {
          color: '#FF0000',
        },
    },
    errorOutlined: {
        '&$cssFocused $notchedOutline': {
          borderColor: '#FF0000',
        },
    },
    cssFocused: {},
    notchedOutline: {}
})

class GoogleMUIAutoComplete extends Component {
    constructor(props){
        super(props);

        this.state = {
            onFocus: false,
            isTypping: false,
            error: false,
            sendAddressTypedEvent: true
        };

        this.onSuggestionSelected = this.onSuggestionSelected.bind(this)
    }

    componentDidMount(){
        const config = {
            types: ['address'],
            componentRestrictions: {country: "us"}
        };
        this.autocomplete = new google.maps.places.Autocomplete(this.input, config);
        this.event = this.autocomplete.addListener('place_changed', this.onSuggestionSelected.bind(this));
    }

    submitAddress(address) {
        this.props.onAddressSelected(this.props.message, address);
    }

    onSuggestionSelected() {
        this.submitAddress(this.autocomplete.getPlace());
    }

    getHelperText(consts){
        if(this.state.isTypping && !this.state.error){
            return consts.inTyppingMsg;
        }
        else{
            if(this.state.onFocus){
                return consts.onFocusMsg;
            }
            return '';
        }
    }

    createAutocompleteRequest(inputValue) {
        return {
          input: inputValue,
          types: ['address'],
          componentRestrictions:{
            country: "us"
          }
        };
    }

    onChange(e){
        let value = e.target.value;
        if(value === ''){
            this.setState({isTypping: false});
            return;
        }
        if(!this.state.isTypping){
            this.setState({isTypping: true});
        }
        if (this.state.sendAddressTypedEvent){
            WorthyApi.sendAddressTypedEvent(this.props.itemId)
            this.setState({sendAddressTypedEvent: false})
        }
        setTimeout(() => {
            let container = document.querySelectorAll('.pac-container');
            if(!container[container.length-1].children.length > 0){
                this.setState({error: true});
            }
            else{
                 if(this.state.error){
                    this.setState({error: false});
                }
            }
        }, 500);
    }

    render(){
        const { classes } = this.props;
        let consts = I18n.getString('itemPage::AddressWaiting::consts');

        return (
            <div id={this.props.id} className="message-input-container message-google-mui-auto-complete input-root">
                <div>
                    <TextField
                        variant="outlined"
                        inputRef={input => (this.input = input)}
                        value={this.props.value}
                        label={this.props.message.text}
                        placeholder={consts.placeholder}
                        className="input-google-maps-auto-complete"
                        autoFocus={this.props.autoFocus || true}
                        helperText={this.getHelperText(consts)}
                        InputLabelProps={{
                            classes: {
                                root: this.state.error ? classes.errorLabel : classes.label,
                                focused: classes.cssFocused,
                            },
                        }}
                        InputProps={{
                            classes: {
                                root: this.state.error ? classes.errorOutlined : classes.outlined,
                                focused: classes.cssFocused,
                                notchedOutline: classes.notchedOutline,
                            },
                        }}
                        FormHelperTextProps={{
                            classes: {
                                root: this.state.error ? classes.errorLabel : classes.label,
                                focused: classes.cssFocused
                            }
                        }}
                        onChange={(e) => {this.onChange(e)}}
                        onFocus={ () => {
                            if(!this.state.onFocus){
                            this.setState({onFocus: true});
                        }}}
                        onBlur={() => {
                            this.setState({onFocus: false, isTypping: false});
                        }}
                    />
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(GoogleMUIAutoComplete);